// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"e1ae1d17","170":"daf92d24","639":"2e7d9353"}[chunkId] + ".chunk.js";
};